import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/scenic-detail.vue'
wx.createPage(MiniProgramPage)